export default "__VITE_ASSET__DWH1rFKz__"